module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("bqfwD"))).then(() => parcelRequire('gyV0H'));